class CustomJSON{
    parse(text:string, nullIfInvalid:boolean = false) {
        if(!nullIfInvalid){
            return JSON.parse(text)
        }
        if(this.isJsonString(text)){
            return JSON.parse(text);
        }
        return null; 
    } 
    stringify(text:string){
        return JSON.stringify(text);
    } 

    private isJsonString(text:string) {
        try {
            JSON.parse(text);
        } catch (e) {
            return false;
        }
        return true;
    }
}

export default new CustomJSON();